// notify-popup.js - Complete Notify Widget Implementation with Translations
(function() {
    'use strict';
    
    // Create NotifyWidget object
    window.NotifyWidget = {
        // Current product/variant data
        currentData: {},
        
        // Open the popup
        open: function(button) {
            console.log('NotifyWidget.open called', button);
            
            // Get product data from button attributes
            const productId = button.getAttribute('data-product-id');
            const productName = button.getAttribute('data-product-name');
            const variantName = button.getAttribute('data-product-variant');
            const variantId = button.getAttribute('data-variant-id');
            
            // Store current data
            this.currentData = {
                productId: productId,
                productName: productName,
                variantName: variantName,
                variantId: variantId
            };
            
            // Update popup content
            const popup = document.getElementById('notifyPopup');
            const productNameElement = document.getElementById('notifyProductName');
            
            if (!popup) {
                console.error('Notify popup element not found');
                return;
            }
            
            // Update ALLEEN de product naam, niet de hele description
            if (productNameElement && productName) {
                productNameElement.textContent = productName;
            }
            
            // Store variant info on popup for form submission
            popup.setAttribute('data-variant-id', variantId || '');
            popup.setAttribute('data-product-id', productId || '');
            popup.setAttribute('data-product-name', productName || '');
            popup.setAttribute('data-variant-name', variantName || '');
            
            // Show popup
            popup.classList.add('show');
           document.body.style.overflow = 'hidden';
            document.body.classList.add('notify-popup-open');
            
            // Apply translations AFTER popup is shown
            setTimeout(() => {
                const currentLang = window.detectNotifyLanguage ? window.detectNotifyLanguage() : 'en';
                if (window.applyNotifyTranslations) {
                    window.applyNotifyTranslations(currentLang);
                }
                
                // Setup language change handler
                const langSelect = document.getElementById('notifyLanguage');
                if (langSelect) {
                    langSelect.onchange = function() {
                        if (this.value && window.applyNotifyTranslations) {
                            window.applyNotifyTranslations(this.value);
                        }
                    };
                }
                
                // Focus on email input
                const emailInput = document.getElementById('notifyEmail');
                if (emailInput) {
                    emailInput.focus();
                }
            }, 100);
        },
        
        // Close the popup
        close: function() {
            const popup = document.getElementById('notifyPopup');
            if (popup) {
                popup.classList.remove('show');
               document.body.style.overflow = '';
                document.body.classList.remove('notify-popup-open');
            }
            
            // Reset form and messages
            const form = document.getElementById('notifyForm');
            const messageDiv = document.getElementById('notifyMessage');
            
            if (form) {
                form.reset();
                form.style.display = 'block';
            }
            
            if (messageDiv) {
                messageDiv.style.display = 'none';
                messageDiv.innerHTML = '';
            }
            
            // Reset button state
            this.resetSubmitButton();
        },
        
        // Show loading state on submit button
        showLoading: function() {
            const submitBtn = document.getElementById('notifySubmitBtn');
            const submitText = document.getElementById('notifySubmitText');
            const spinner = submitBtn?.querySelector('.notify-spinner');
            
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.classList.add('loading');
            }
            if (submitText) submitText.style.display = 'none';
            if (spinner) spinner.style.display = 'inline-block';
        },
        
        // Reset submit button state
        resetSubmitButton: function() {
            const submitBtn = document.getElementById('notifySubmitBtn');
            const submitText = document.getElementById('notifySubmitText');
            const spinner = submitBtn?.querySelector('.notify-spinner');
            
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.classList.remove('loading');
            }
            if (submitText) submitText.style.display = 'inline';
            if (spinner) spinner.style.display = 'none';
        },
        
        // Show message
        showMessage: function(message, type = 'success') {
            const messageDiv = document.getElementById('notifyMessage');
            if (messageDiv) {
                messageDiv.innerHTML = `<div class="notify-message-${type}">${message}</div>`;
                messageDiv.style.display = 'block';
            }
        },
        
        // Submit form data
        submitForm: function(formData) {
            this.showLoading();
            
            // Get Klaviyo config (single source of truth: snippets/klaviyo-config.liquid)
            const config = window.KlaviyoConfig || {};
            const klaviyoAccountId = config.accountId;
            
            // Never fall back to a hardcoded account: a wrong ID would silently
            // send this shop's subscribers to another shop's Klaviyo account.
            if (!klaviyoAccountId) {
                console.error(
                    '[Klaviyo] No account ID configured. Set the Klaviyo Public API Key ' +
                    'under Theme settings > Klaviyo. Submission blocked.'
                );
                this.showMessage('There was an error. Please try again later.', 'error');
                this.resetSubmitButton();
                return;
            }
            
            // Check if Klaviyo is loaded
            if (!window.klaviyo || !window.klaviyo.push) {
                console.error('Klaviyo not loaded');
                this.showMessage('There was an error. Please try again later.', 'error');
                this.resetSubmitButton();
                return;
            }

            // Prepare subscriber data with all fields
            const subscriberData = {
                '$email': formData.email,
                '$country': formData.country,
                '$language': formData.language,
                'Country': formData.country,
                'Language': formData.language,
                '$locale': formData.language + '_' + formData.country.toUpperCase(),
                'Newsletter_Consent': formData.newsletter ? 'Yes' : 'No',
                'Last_BIS_Subscription': new Date().toISOString()
            };

            // Track Back in Stock subscription data
            const backInStockData = {
                'ProductID': formData.productId,
                'ProductName': formData.productName,
                'VariantID': formData.variantId,
                'VariantName': formData.variantName,
                'Platform': 'Shopify',
                'Store': config.shopDomain || window.location.hostname
            };
            
            try {
                // First identify the subscriber with all properties
                window.klaviyo.push(['identify', subscriberData]);
                
                // If newsletter checkbox is checked, update email consent
                if (formData.newsletter) {
                    // Track newsletter signup
                    window.klaviyo.push(['track', 'Newsletter Signup', {
                        '$email': formData.email,
                        'Source': 'Back in Stock Popup',
                        'Newsletter_Consent': 'Yes'
                    }]);
                    
                    // Update email consent status
                    window.klaviyo.push(['track', 'Consented to Receive Email Marketing', {
                        '$email': formData.email,
                        '$consent_method': 'Back in Stock Form',
                        '$consent_timestamp': new Date().toISOString()
                    }]);
                    
                    // Also try to update profile consent directly
                    window.klaviyo.push(['identify', {
                        '$email': formData.email,
                        '$consent': ['email'],
                        '$consent_method': 'Klaviyo Form'
                    }]);
                }
                
                // Track Back in Stock subscription
                window.klaviyo.push(['track', 'Back In Stock Subscribed', backInStockData]);
                
                // Also use the Klaviyo Back in Stock API endpoint
                if (formData.variantId) {
                    const klaviyoForm = {
                        a: klaviyoAccountId,
                        email: formData.email,
                        variant: formData.variantId,
                        platform: 'shopify'
                    };
                    
                    // Make AJAX request to Klaviyo
                    fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams(klaviyoForm).toString()
                    }).then(response => {
                        console.log('Klaviyo API response:', response);
                    }).catch(error => {
                        console.error('Klaviyo API error:', error);
                    });
                }
                
                // Show success message (this will be translated)
                const successMessage = window.notifyTranslations && window.notifyTranslations[formData.language] 
                    ? window.notifyTranslations[formData.language].success_message 
                    : 'Thank you! We\'ll notify you when this item is back in stock.';
                this.showMessage(successMessage);
                
                // Hide form
                const form = document.getElementById('notifyForm');
                if (form) {
                    form.style.display = 'none';
                }
                
                // Auto-close after 3 seconds
                setTimeout(() => {
                    this.close();
                }, 3000);
                
            } catch (error) {
                console.error('Error submitting to Klaviyo:', error);
                this.showMessage('There was an error. Please try again.', 'error');
            } finally {
                this.resetSubmitButton();
            }
        }
    };
    
    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        console.log('NotifyWidget initializing...');
        
        // Form submission handler
        const form = document.getElementById('notifyForm');
        if (form) {
            form.addEventListener('submit', function(e) {
                e.preventDefault();
                
                // Get form values
                const email = document.getElementById('notifyEmail')?.value;
                const country = document.getElementById('notifyCountry')?.value;
                const language = document.getElementById('notifyLanguage')?.value;
                const newsletter = document.getElementById('notifyNewsletter')?.checked;
                
                // Get product/variant data from popup attributes
                const popup = document.getElementById('notifyPopup');
                const variantId = popup?.getAttribute('data-variant-id');
                const productId = popup?.getAttribute('data-product-id');
                const productName = popup?.getAttribute('data-product-name');
                const variantName = popup?.getAttribute('data-variant-name');
                
                // Validate required fields
                if (!email || !country || !language) {
                    NotifyWidget.showMessage('Please fill in all required fields.', 'error');
                    return;
                }
                
                // Submit form data
                NotifyWidget.submitForm({
                    email: email,
                    country: country,
                    language: language,
                    newsletter: newsletter,
                    productId: productId,
                    productName: productName,
                    variantId: variantId,
                    variantName: variantName
                });
            });
        }
        
        // Close button handler
        const closeButton = document.getElementById('notify-popup-close');
        if (closeButton) {
            closeButton.addEventListener('click', function() {
                NotifyWidget.close();
            });
        }
        
        // Close on overlay click
        const popup = document.getElementById('notifyPopup');
        if (popup) {
            popup.addEventListener('click', function(e) {
                if (e.target === popup) {
                    NotifyWidget.close();
                }
            });
        }
        
        // Close on ESC key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && popup && popup.classList.contains('show')) {
                NotifyWidget.close();
            }
        });
        
        // Set default language based on page language
        const languageSelect = document.getElementById('notifyLanguage');
        if (languageSelect) {
            const pageLang = document.documentElement.lang || 'en';
            const langCode = pageLang.split('-')[0]; // Get language code without region
            
            // Set value if option exists
            const options = languageSelect.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].value === langCode) {
                    languageSelect.value = langCode;
                    break;
                }
            }
        }
        
        console.log('NotifyWidget initialized successfully');
    });
    
    // Also make sure NotifyWidget is available immediately
    if (!window.NotifyWidget) {
        console.log('NotifyWidget created and attached to window');
    }
    
})();

// Translations
window.notifyTranslations = {
    en: {
        title: 'BACK IN STOCK ALERT!',
        description: 'Register to receive a notification when',
        back_in_stock: 'comes back in stock.',
        email_placeholder: 'Type your email',
        select_country: 'Select your country',
        select_language: 'Select your language',
        newsletter: 'Yes, I want to receive The Mouse Mansion news, offers, and 10% discount on my next order!',
        subscribe: 'subscribe',
        success_message: 'Thank you! We\'ll notify you when this item is back in stock.'
    },
    nl: {
        title: 'WEER OP VOORRAAD MELDING!',
        description: 'Registreer om een melding te ontvangen wanneer',
        back_in_stock: 'weer op voorraad is.',
        email_placeholder: 'Vul je e-mailadres in',
        select_country: 'Selecteer je land',
        select_language: 'Selecteer je taal',
        newsletter: 'Ja, ik wil Het Muizenhuis nieuws, aanbiedingen en 10% korting op mijn volgende bestelling ontvangen!',
        subscribe: 'aanmelden',
        success_message: 'Bedankt! We sturen je een bericht als dit artikel weer op voorraad is.'
    },
    de: {
        title: 'WIEDER VERFÜGBAR BENACHRICHTIGUNG!',
        description: 'Registrieren Sie sich, um benachrichtigt zu werden, wenn',
        back_in_stock: 'wieder verfügbar ist.',
        email_placeholder: 'Geben Sie Ihre E-Mail ein',
        select_country: 'Wählen Sie Ihr Land',
        select_language: 'Wählen Sie Ihre Sprache',
        newsletter: 'Ja, ich möchte Das Mäusehaus Neuigkeiten, Angebote und 10% Rabatt auf meine nächste Bestellung erhalten!',
        subscribe: 'anmelden',
        success_message: 'Vielen Dank! Wir benachrichtigen Sie, wenn dieser Artikel wieder verfügbar ist.'
    },
    fr: {
        title: 'ALERTE RETOUR EN STOCK!',
        description: 'Inscrivez-vous pour être notifié quand',
        back_in_stock: 'sera de nouveau en stock.',
        email_placeholder: 'Entrez votre email',
        select_country: 'Sélectionnez votre pays',
        select_language: 'Sélectionnez votre langue',
        newsletter: 'Oui, je veux recevoir les nouvelles, offres et 10% de réduction sur ma prochaine commande de La Maison des Souris!',
        subscribe: 's\'inscrire',
        success_message: 'Merci! Nous vous préviendrons quand cet article sera de nouveau en stock.'
    },
    es: {
        title: '¡ALERTA DE DISPONIBILIDAD!',
        description: 'Regístrate para recibir una notificación cuando',
        back_in_stock: 'vuelva a estar disponible.',
        email_placeholder: 'Introduce tu email',
        select_country: 'Selecciona tu país',
        select_language: 'Selecciona tu idioma',
        newsletter: '¡Sí, quiero recibir noticias, ofertas y 10% de descuento en mi próximo pedido de La Casa del Ratón!',
        subscribe: 'suscribir',
        success_message: '¡Gracias! Te avisaremos cuando este artículo vuelva a estar disponible.'
    },
    it: {
        title: 'AVVISO DISPONIBILITÀ!',
        description: 'Registrati per ricevere una notifica quando',
        back_in_stock: 'tornerà disponibile.',
        email_placeholder: 'Inserisci la tua email',
        select_country: 'Seleziona il tuo paese',
        select_language: 'Seleziona la tua lingua',
        newsletter: 'Sì, voglio ricevere notizie, offerte e 10% di sconto sul mio prossimo ordine da La Casa del Topo!',
        subscribe: 'iscriviti',
        success_message: 'Grazie! Ti avviseremo quando questo articolo tornerà disponibile.'
    }
};

// Language detection function
window.detectNotifyLanguage = function() {
    const path = window.location.pathname.toLowerCase();
    const urlLangs = ['nl', 'de', 'fr', 'es', 'it'];
    
    for (let lang of urlLangs) {
        if (path.includes('/' + lang + '/') || path.startsWith('/' + lang)) {
            return lang;
        }
    }
    
    const htmlLang = document.documentElement.lang?.toLowerCase().split('-')[0];
    if (htmlLang && window.notifyTranslations[htmlLang]) {
        return htmlLang;
    }
    
    return 'en';
};

// Apply translations function
window.applyNotifyTranslations = function(lang) {
    console.log('Applying translations for:', lang);
    const translations = window.notifyTranslations[lang] || window.notifyTranslations.en;
    
    // Update all elements with data-translate
    document.querySelectorAll('[data-translate]').forEach(element => {
        const key = element.getAttribute('data-translate');
        if (translations[key]) {
            element.textContent = translations[key];
        }
    });
    
    // Update placeholders
    document.querySelectorAll('[data-translate-placeholder]').forEach(element => {
        const key = element.getAttribute('data-translate-placeholder');
        if (translations[key]) {
            element.placeholder = translations[key];
        }
    });
    
    // Update language dropdown
    const langSelect = document.getElementById('notifyLanguage');
    if (langSelect && langSelect.value !== lang) {
        langSelect.value = lang;
    }
};

// Test function
window.testNotifyTranslation = function(lang) {
    console.log('Testing translation for:', lang);
    window.applyNotifyTranslations(lang);
};

// Add CSS if not already present
(function() {
    if (!document.querySelector('#notify-spinner-styles')) {
        const style = document.createElement('style');
        style.id = 'notify-spinner-styles';
        style.textContent = `
            .notify-spinner {
                display: inline-block;
                width: 16px;
                height: 16px;
                border: 2px solid rgba(255, 255, 255, 0.3);
                border-radius: 50%;
                border-top-color: #fff;
                animation: notify-spin 0.8s linear infinite;
            }
            
            @keyframes notify-spin {
                to { transform: rotate(360deg); }
            }
            
            .notify-submit-btn.loading {
                opacity: 0.7;
                cursor: not-allowed;
            }
            
            .notify-message-success {
                color: #155724;
                background-color: #d4edda;
                border: 1px solid #c3e6cb;
                padding: 12px;
                border-radius: 4px;
                margin-bottom: 15px;
            }
            
            .notify-message-error {
                color: #721c24;
                background-color: #f8d7da;
                border: 1px solid #f5c6cb;
                padding: 12px;
                border-radius: 4px;
                margin-bottom: 15px;
            }
        `;
        document.head.appendChild(style);
    }
})();